import { useEffect, useState } from "react";
import useMediaQuery from "~/common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/common/utils/screenSizes";
import { fetchLmbtConfiguratorUrl } from "~/domains/product/api/fetchLmbtConfiguratorUrl";
import { type PdpPageProductData } from "~/features/productDetails/models/PdpPageProductData";

interface CalculationTabProps {
  product: Pick<PdpPageProductData, "lmbtConfigurator">;
}

export const ConfiguratorTab = (props: CalculationTabProps) => {
  const { product } = props;
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);
  const code = product.lmbtConfigurator;
  const [resolvedUrl, setResolvedUrl] = useState<{ code: string; url: string }>();

  useEffect(() => {
    if (!code) {
      return;
    }

    const abortController = new AbortController();
    void fetchLmbtConfiguratorUrl(code, abortController.signal)
      .then((url) => {
        if (!abortController.signal.aborted) {
          setResolvedUrl({ code, url });
        }
      })
      .catch(() => {
        if (!abortController.signal.aborted) {
          setResolvedUrl(undefined);
        }
      });
    return () => {
      abortController.abort();
    };
  }, [code]);

  const configuratorUrl = resolvedUrl && resolvedUrl.code === code ? resolvedUrl.url : undefined;
  return (
    <div className={"scha__ignore-margins " + (isDesktop ? undefined : "w-100")}>
      {configuratorUrl ? (
        <iframe className="scha__pdp-iframe" id="configuratorIframe" scrolling="yes" src={configuratorUrl}></iframe>
      ) : null}
    </div>
  );
};
